import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, TrendingDown } from "lucide-react";
import { useLanguage } from "@/shared/components/shared/LanguageContext";

export default function StatCard({ 
  title, 
  value, 
  change, 
  changeType = "positive", 
  icon: Icon, 
  iconColor = "bg-blue-500",
  delay = 0 
}) {
  let t = null;
  try {
    const langContext = useLanguage();
    t = langContext?.t;
  } catch (e) {
  }

  const displayValue = typeof value === "string"
    ? value.replace(/^R\s*s[\s\u00A0]*/i, "Rs")
    : value;
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      className="relative bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-slate-100 hover:shadow-md transition-shadow"
    >
      <div className="min-w-0 pr-16 sm:pr-20">
          <p className="text-xs sm:text-sm font-medium text-slate-500 mb-1 truncate">{title}</p>
          <h3 className="text-lg sm:text-xl font-bold text-slate-900">{displayValue}</h3>
          {change && (
            <div className={`flex items-center gap-1 mt-2 text-xs sm:text-sm ${
              changeType === "positive" ? "text-emerald-600" : "text-red-500"
            }`}>
              {changeType === "positive" ? (
                <TrendingUp className="h-3 w-3 sm:h-4 sm:w-4 flex-shrink-0" />
              ) : (
                <TrendingDown className="h-3 w-3 sm:h-4 sm:w-4 flex-shrink-0" />
              )}
              <span className="font-medium">{change}</span>
              <span className="text-slate-400 hidden sm:inline">{t ? t("vsLastPeriod") : "vs last period"}</span>
            </div>
          )}
      </div>
      <div className={`absolute top-4 right-4 sm:top-6 sm:right-6 ${iconColor} w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg`}>
          <Icon className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
      </div>
    </motion.div>
  );
}